import { render, staticRenderFns } from "./ShopHeader.vue?vue&type=template&id=02ad9c02&scoped=true&"
import script from "./ShopHeader.vue?vue&type=script&lang=ts&"
export * from "./ShopHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShopHeader.vue?vue&type=style&index=0&id=02ad9c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ad9c02",
  null
  
)

export default component.exports